import React from 'react';
import PropTypes from 'prop-types';
import ReactConfirmAlert from 'react-confirm-alert';
import { CustomPopupBody } from './CustomPopupBody';

function CustomPopup({ showPopup, body, title, onCancel, isLoading, subtitle, closeOnClickOutside, cancelButtonId, overlayClassName }) {
    return showPopup ?
        <ReactConfirmAlert
            closeOnClickOutside={closeOnClickOutside}
            onClickOutside={closeOnClickOutside ? onCancel : () => { }}
            customUI={() =>
                <CustomPopupBody
                    cancelButtonId={cancelButtonId}
                    title={title}
                    body={body}
                    onCancel={onCancel}
                    isLoading={isLoading}
                    subtitle={subtitle}
                />}
            overlayClassName={overlayClassName}
        />
        : <></>;
}

CustomPopup.propTypes = {
    showPopup: PropTypes.bool.isRequired,
    body: PropTypes.object.isRequired,
    onCancel: PropTypes.func,
    title: PropTypes.string,
    isLoading: PropTypes.bool,
    subtitle: PropTypes.string,
    closeOnClickOutside: PropTypes.bool,
    cancelButtonId: PropTypes.string,
    overlayClassName: PropTypes.string
};

export default CustomPopup;